import {Component, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.css']
})


export class TaskListComponent implements OnInit {

  @Input()
  calendar

  @Input()
  public currentPage : number;
  @Output()
  public lastPageIndex : number;
  @Input()
  public taskCount : number;

  public pageSize : number = 10;


  constructor() { }

  ngOnInit() {
  }

}










// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/task-list/task-list.component.ts